import { Routes } from '@angular/router';
import { ShellComponent } from './shared/shell/shell.component';
import { authRedirectGuard } from './core/guards/auth-redirect.guard';
import { authGuard } from './core/guards/auth.guard';
import { tenantAdminGuard } from './core/guards/tenant-admin.guard';
import { unsavedChangesGuard } from './core/guards/unsaved-changes.guard';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [authRedirectGuard],
    loadComponent: () =>
      import('./pages/authentication/login/login.component').then(
        (m) => m.LoginComponent,
      ),
  },
  {
    path: 'forgot-password',
    canActivate: [authRedirectGuard],
    loadComponent: () =>
      import('./pages/authentication/forgot-password/forgot-password.component').then(
        (m) => m.ForgotPasswordComponent,
      ),
  },
  {
    path: 'reset-password',
    canActivate: [authRedirectGuard],
    loadComponent: () =>
      import('./pages/authentication/reset-password/reset-password.component').then(
        (m) => m.ResetPasswordComponent,
      ),
  },
  {
    path: 'accept-invitation',
    canActivate: [authRedirectGuard],
    loadComponent: () =>
      import('./pages/authentication/accept-invitation/accept-invitation.component').then(
        (m) => m.AcceptInvitationComponent,
      ),
  },
  {
    path: 'confirm-email-change',
    loadComponent: () =>
      import(
        './pages/authentication/confirm-email-change/confirm-email-change.component'
      ).then((m) => m.ConfirmEmailChangeComponent),
  },
  {
    path: 'verify-otp',
    canActivate: [authRedirectGuard],
    loadComponent: () =>
      import('./pages/authentication/verify-otp/verify-otp.component').then(
        (m) => m.VerifyOtpComponent,
      ),
  },
  {
    path: '',
    component: ShellComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./pages/dashboard/dashboard.component').then(
            (m) => m.DashboardComponent,
          ),
        children: [
          // Must precede ':id', which would otherwise swallow 'create' as a dish id.
          {
            path: 'create',
            canDeactivate: [unsavedChangesGuard],
            loadComponent: () =>
              import('./pages/dashboard/dish-drawer/dish-create-drawer.component').then(
                (m) => m.DishCreateDrawerComponent,
              ),
          },
          {
            path: ':id',
            canDeactivate: [unsavedChangesGuard],
            loadComponent: () =>
              import('./pages/dashboard/dish-drawer/dish-drawer.component').then(
                (m) => m.DishDrawerComponent,
              ),
          },
        ],
      },
      // Absolute redirectTo carries query params through the UrlSerializer (Angular 20).
      { path: 'members', redirectTo: '/settings/household?tab=members' },
      {
        path: 'audit',
        canActivate: [tenantAdminGuard],
        loadComponent: () =>
          import('./pages/audit/audit-log.component').then(
            (m) => m.AuditLogComponent,
          ),
      },
      {
        path: 'settings/profile',
        canDeactivate: [unsavedChangesGuard],
        loadComponent: () =>
          import('./pages/profile-settings/profile-settings.component').then(
            (m) => m.ProfileSettingsComponent,
          ),
      },
      {
        // Open to every role — MEMBER sees only the diets tab, HouseholdSettingsComponent
        // enforces that split itself since the page is no longer all-admin.
        path: 'settings/household',
        loadComponent: () =>
          import('./pages/household-settings/household-settings.component').then(
            (m) => m.HouseholdSettingsComponent,
          ),
      },
      {
        path: 'not-found',
        loadComponent: () =>
          import('./pages/not-found-page.component').then(
            (m) => m.NotFoundPageComponent,
          ),
      },
      { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
      {
        path: '**',
        redirectTo: '/not-found',
      },
    ],
  },
];
